<template>
<ItpBox
  direction="column"
>
  <DIV
    v-if="items && !items.length"
  >
    {{ 'No references added.'|pgettext('InvoiceReferences') }}
  </DIV>
  <ItpBox
    direction="column"
    v-if="items && items.length"
  >
    <ItpBox
      :key="item.id"
      class="app-invoice-reference-item border rounded rounded-lg p-2 mb-2 w-100 overflow-hidden"
      v-for="item in items"
    >
      <InvoiceReferenceItem
        :item="item"
        class="w-100 overflow-hidden"
      >
      </InvoiceReferenceItem>
      <ItpLink
        icon="fa-times"
        class="ml-2 ml-auto"
        @click="evh_4044930568678877_click($event, {item})"
      >
      </ItpLink>
    </ItpBox>
  </ItpBox>
  <ItpLink
    :icon="$config.addIcon"
    :text="'Add reference'|gettext"
    class="ml-auto"
    @click.prevent="evh_8358196963355853_clickPrevent($event, {})"
  >
  </ItpLink>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceReferences extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get items() {
    if (this.loaded) {

      return this.invoice.references.data
    }
    return null;
  }

  async act_4044930568678877_emit_9266_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4044930568678877_emit_9266, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4044930568678877_crud_9264_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_4044930568678877_crud_9264, alias=undefined
    return {
      objectType: "invoice_reference",
      op: "delete",
      data: {
        invoice_id: this.invoice.id,
        etag: this.invoice.etag,
        reference_type: $event.scope.item.object,
        reference_id: $event.scope.item.id,
      }
      ,
    }
  }

  async act_4044930568678877_crud_9264_getConfirm($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_4044930568678877_crud_9264, alias=undefined
    return {
      message: this.$fn.gettext("Please confirm deleting the reference."),
      btnOk: this.$fn.gettext("Delete reference"),
      severity: "warning",
    }
  }

  async evh_4044930568678877_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4044930568678877_click.executeFromDOM(this, event, scope);
  }

  async act_8358196963355853_emit_9270_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8358196963355853_emit_9270, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_8358196963355853_close_9269_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8358196963355853_close_9269, alias=undefined
    return !!$event.data.modalResult && !!$event.data.modalResult.ok
  }

  async act_8358196963355853_showModal_9268_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8358196963355853_showModal_9268, alias=undefined
    return {
      name: "InvoiceReferenceSearch",
      props: {
        invoiceId: this.invoice.id,
      }
      ,
    }
  }

  async evh_8358196963355853_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8358196963355853_clickPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_4044930568678877_emit_9266: actions.EmitAction;
    evh_4044930568678877_success_9265: actions.EventHandlerImpl;
    act_4044930568678877_crud_9264: actions.CRUDAction;
    evh_4044930568678877_click_9263: actions.EventHandlerImpl;
    evh_4044930568678877_click: actions.EventHandlerGroup;
    act_8358196963355853_emit_9270: actions.EmitAction;
    evh_8358196963355853_close_9269: actions.EventHandlerImpl;
    act_8358196963355853_showModal_9268: actions.ShowModalAction;
    evh_8358196963355853_clickPrevent_9267: actions.EventHandlerImpl;
    evh_8358196963355853_clickPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_4044930568678877_emit_9266 = new actions.EmitAction(
      {
        actionArgs: this.act_4044930568678877_emit_9266_getActionArgs,
        events: [],
      }
    );
    const evh_4044930568678877_success_9265 = new actions.EventHandlerImpl(
      {
        action: act_4044930568678877_emit_9266,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4044930568678877_crud_9264 = new actions.CRUDAction(
      {
        actionArgs: this.act_4044930568678877_crud_9264_getActionArgs,
        confirm: this.act_4044930568678877_crud_9264_getConfirm,
        events: [evh_4044930568678877_success_9265],
      }
    );
    const evh_4044930568678877_click_9263 = new actions.EventHandlerImpl(
      {
        action: act_4044930568678877_crud_9264,
        event: "click",
        displayName: "crud",
      }
    );
    const evh_4044930568678877_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4044930568678877_click_9263],
      }
    );
    const act_8358196963355853_emit_9270 = new actions.EmitAction(
      {
        actionArgs: this.act_8358196963355853_emit_9270_getActionArgs,
        events: [],
      }
    );
    const evh_8358196963355853_close_9269 = new actions.EventHandlerImpl(
      {
        action: act_8358196963355853_emit_9270,
        event: "close",
        when: this.evh_8358196963355853_close_9269_getWhen,
        displayName: "emit",
      }
    );
    const act_8358196963355853_showModal_9268 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8358196963355853_showModal_9268_getActionArgs,
        events: [evh_8358196963355853_close_9269],
      }
    );
    const evh_8358196963355853_clickPrevent_9267 = new actions.EventHandlerImpl(
      {
        action: act_8358196963355853_showModal_9268,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_8358196963355853_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_8358196963355853_clickPrevent_9267],
      }
    );
    return {
      act_4044930568678877_emit_9266,
      evh_4044930568678877_success_9265,
      act_4044930568678877_crud_9264,
      evh_4044930568678877_click_9263,
      evh_4044930568678877_click,
      act_8358196963355853_emit_9270,
      evh_8358196963355853_close_9269,
      act_8358196963355853_showModal_9268,
      evh_8358196963355853_clickPrevent_9267,
      evh_8358196963355853_clickPrevent,
    }
  }
}

Vue.component("UcInvoiceReferences", UcInvoiceReferences);

</script>